/**
 * Official UTMify tracking scripts.
 * Loaded once on app bootstrap from index.tsx via loadUtmify().
 *
 * IMPORTANT: the UTMify pixel script (pixel.js) reads `window.pixelId` during its
 * own initialization. If that global is missing it crashes internally with
 * "undefined is not an object (evaluating 'wt.lead._id')". So the pixel is only
 * injected once a real account id is configured below; the UTM parameter tracker
 * (latest.js) requires no id and always loads.
 *
 * To enable the pixel, paste your UTMify pixel id here.
 */
const UTMIFY_PIXEL_ID = ''

const UTMIFY_PIXEL_SRC = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js'
const UTMIFY_UTMS_SRC = 'https://cdn.utmify.com.br/scripts/utms/latest.js'

declare global {
  interface Window {
    pixelId?: string
    __utmifyLoaded?: boolean
  }
}

export function loadUtmify(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.__utmifyLoaded) return
  window.__utmifyLoaded = true

  // UTMify UTM parameter tracker — no account id required.
  const utms = document.createElement('script')
  utms.src = UTMIFY_UTMS_SRC
  utms.async = true
  utms.defer = true
  utms.setAttribute('data-utmify-prevent-xcod-sck', '')
  utms.setAttribute('data-utmify-prevent-subid', '')
  document.head.appendChild(utms)

  // UTMify pixel — requires window.pixelId to exist BEFORE the script runs.
  if (!UTMIFY_PIXEL_ID) return

  window.pixelId = UTMIFY_PIXEL_ID

  const pixel = document.createElement('script')
  pixel.async = true
  pixel.defer = true
  pixel.src = UTMIFY_PIXEL_SRC
  document.head.appendChild(pixel)
}
